import React from "react";
import { Link } from "react-scroll"
// import {Link} from 'react-scroll'
import {
  Box,
  HStack,
  IconButton,
  useColorModeValue,
  useColorMode,
  useDisclosure,
  Avatar,
  Link as ChakraLink,
  Flex,
  Stack,
  Button,
} from "@chakra-ui/react";
import { FaMoon, FaSun, FaGithub, FaLinkedin } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import img from '../../Config/SV.png'
import NavLink from "./NavLink";

const links = [
  { name: "About", id: "about" },
  { name: "Tech ", id: "tech" },
  { name: "Projects", id: "projects" },
  { name: "Contact", id: "contact" },
];

function Navbar() {
  const { toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      position={'fixed'}
      w={'100%'}
      zIndex={2}
      bg={useColorModeValue("white", "gray.800")}
      mb={20}
      borderBottomColor={useColorModeValue("white", "blue.900")}
      boxShadow={"md"}
    >
      <Flex
        justifyContent="space-between"
        alignItems={"center"}
        w={["90%", "85%", "80%"]}
        py={4}
        maxW="container.lg"
        mx="auto"
      >
        <IconButton
          size={"md"}
          icon={isOpen ? <AiOutlineClose /> : <GiHamburgerMenu />}
          aria-label={"Open Menu"}
          display={["inherit", "inherit", "none"]}
          onClick={isOpen ? onClose : onOpen}
        />

        <HStack spacing={4} alignItems={"center"}>

          <Link to="home" spy={true} smooth={true} offset={50} duration={2000} onClick={onClose}>
            <Box mr={5}>
              <Avatar cursor={'pointer'} size={"md"} src={img} />
            </Box>
          </Link>



          <HStack as={"nav"} spacing={4} display={{ base: "none", md: "flex" }}>
            {links.map((link, i) => (
              <NavLink
                key={i}
                to={link.id}
                name={link.name}
                fontSize={15}
                onClick={() => onClose()}
              />
            ))}
            <Button
              as={ChakraLink}
              href='https://drive.google.com/file/d/1b-PGZK_JrQDcOtYpzlOBR4wixRkGXqZh/view?usp=sharing'
              target="_blank"
              w={"full"}
              size="sm"
              fontSize={15}
            >
              Resume
            </Button>
          </HStack>
        </HStack>

        <HStack alignItems={"center"}>
          <IconButton
            as={ChakraLink}
            href={"https://github.com/S-hub1996"}
            size={"md"}
            icon={<FaGithub />}
            aria-label={"Github account"}
            target='blank'
            _hover={{
              textDecoration: "none",
              bg: useColorModeValue("gray.300", "blue.600"),
            }}
            bg={useColorModeValue("white", "gray.700")}
          />
          <IconButton
            as={ChakraLink}
            href={"https://www.linkedin.com/in/shubham-verma-78768a157/"}
            size={"md"}
            icon={<FaLinkedin />}
            aria-label={"Linkdin account"}
            target='blank'
            _hover={{
              textDecoration: "none",
              bg: useColorModeValue("gray.300", "blue.600"),
            }}
            bg={useColorModeValue("white", "gray.700")}
          />
          <IconButton
            variant="outline"
            icon={useColorModeValue(<FaMoon />, <FaSun />)}
            onClick={toggleColorMode}
            aria-label="toggle-dark-mode"
          />
        </HStack>
      </Flex>
      {/* <Progress size="xs" isIndeterminate  /> */}
      {isOpen ? (
        <Box
          pb={4}
          w={["100%", "100%", "80%"]}
          maxW={800}
          display={["inherit", "inherit", "none"]}
        >
          <Stack as={"nav"} spacing={4} alignItems="center" w="">
            {links.map((link, i) => (
              <NavLink
                key={i}
                to={link.id}
                name={link.name}
                w="md"
                onClick={() => onClose()}
              />
            ))}
            <Button
              as={ChakraLink}
              href='https://drive.google.com/file/d/1b-PGZK_JrQDcOtYpzlOBR4wixRkGXqZh/view?usp=sharing'
              target="_blank"
              w="md"
              size="sm"
            >
              Resume
            </Button>
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
}

export default Navbar;